import { render, staticRenderFns } from "./JoiningSummary.vue?vue&type=template&id=5176c2d2&scoped=true"
import script from "./JoiningSummary.vue?vue&type=script&lang=js"
export * from "./JoiningSummary.vue?vue&type=script&lang=js"
import style0 from "./JoiningSummary.vue?vue&type=style&index=0&id=5176c2d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5176c2d2",
  null
  
)

export default component.exports